import { BaseOptions } from './baseOptions';

export class InvoiceMissionOptions extends BaseOptions {
  ownerId?: number;

  constructor() {
    super();

    this.sortCol = 'invoiceMission_id';
    this.sortDir = 'desc';
  }
}
